import React from "react";
// Components ///
// import Button from "../../atoms/button/button";
import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
import Breadcrumb from '../../atoms/breadcrumb/breadcrumb';
import useElementSize from "../../../hooks/useElementSize";

// Styles //
import "./headboardMpcVerificacion.scss";

const HeadboardMpcVerificacion = (props: ReferenciaCabecera) => {
   const headerSize = useElementSize(".m-header");
    return (
        <div className={`o-verification-mpc-breadcrumb`} style={{ marginTop: `${headerSize.height}px` }}>
            <div className={`container`}>
                <Breadcrumb content={props.migaDePan} />
            </div>
        </div>   
    );
};

export default HeadboardMpcVerificacion;
